import { z } from "zod"

export const ImportCompaniesState = z.object({
  status: z.enum(["NOT_STARTED", "RUNNING", "SUCCEEDED", "FAILED"]),
})

export type ImportCompaniesState = z.infer<typeof ImportCompaniesState>
